



































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CircleInfo extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly fill?: string;
}
